/**
 * Ermöglicht die Anzeige der Elemente von Hotspot-Aufgaben.
 * @class directive_v3sMaparea
 * @memberOf v3sWbtPlayerApp:exercise:hotspot
 */
angular.module('v3sWbtPlayerApp').directive('v3sMapareaRepeat', ["$tooltip", "v3sI18nService", function ($tooltip, v3sI18nService) {
    return {
        restrict: 'E',
        scope: true,
        require: ['^v3sDocument', '^v3sHotspot'],
        transclude: true,
        link: function (scope, element, attrs, ctrls, transclude) {
            var v3sDocumentCtrl = ctrls[0];
            var v3sHotSpotCtrl = ctrls[1];
            var wrongAnswers = null;

            //Löscht den momentan angezeigten Tooltip
            function removeTooltip() {
                angular.element(document.querySelector(".tooltip")).remove();
            }

            scope.maparea.setShowFeedback(function () {

                if (scope.maparea.isFeedbackVisible()) {

                    var status = scope.maparea.getStatus();
                    var msg = v3sI18nService.getText([
                        "exercises.fod.hotspot." + status.name,
                        "exercises.fod.general." + status.name
                    ]);

                    //Die falschen Antworten "laden"
                    wrongAnswers = v3sHotSpotCtrl.incorrectMaparea.getUserAnswer();

                    //InstantMode: falsche löschen
                    if (!scope.maparea.completed) {
                        scope.maparea.setTimeoutToDelete();
                    }

                    //Richtige mapareas markieren und Klicks auf der Fläche löschen
                    if (status.correct) {
                        element.addClass("correct");
                        angular.forEach(scope.maparea.clicks, function (click) {
                            if (!!click) {
                                click.remove();
                                removeTooltip();
                            }
                        });

                        //Falsche maparea markieren und die klicks markieren
                    } else {

                        element.addClass('wrong');
                        angular.forEach(scope.maparea.clicks, function (click) {
                            if (!!click && !!click.addClass) {
                                click.addClass("wrong");
                                $tooltip(click, { title: msg });
                            }
                        });
                    }

                    element.css({
                        top: scope.maparea.top + "px",
                        left: scope.maparea.left + "px",
                        width: scope.maparea.width + "px",
                        height: scope.maparea.height + "px"
                    });

                    //Tooltip setzen
                    $tooltip(element, { title: msg });
                }

            });

            // Annotieren für die korrekten Antworten aktivieren
            if (scope.maparea.hasCorrectAnswer()) {
                element[0].id = scope.maparea.id;
                v3sDocumentCtrl.addElement(element, {
                    show: function () {
                        if (element.hasClass("correct") || element.hasClass("wrong")) {
                            return false;
                        }

                        element.addClass("correct");

                        element.css({
                            top: scope.maparea.top + "px",
                            left: scope.maparea.left + "px",
                            width: scope.maparea.width + "px",
                            height: scope.maparea.height + "px"
                        });

                        return true;
                    },
                    hide: function () {
                        element.removeClass("correct");

                        element.css({
                            top: "0",
                            left: "0",
                            width: "0",
                            height: "0"
                        });
                    }
                });
            }
        }
    };
}]);
